<template>
  <div id="app">
    <login ref="login"></login>
    <header class="app_header main" id="app_header">
      <div class="header_item">
        <a href="/" class="logo"><img src="//frontend.originoo.com/originoo_web/logo/logo.png" /></a>
      </div>
      <div class="header_item">
        <!--<el-menu :default-active="nav_activeMenu" :unique-opened="true" :collapse="false" background-color="transparent" active-text-color="#FF7545" text-color="#fff" mode="horizontal" class="el-menu-demo" router>

        <el-menu-item :index="route.name" :route="route" :key="index" v-for="(route, index) in $router.options.routes[$router.options.routes.length - 2].children">
          <span>{{route.name}}</span>
          <img :class="route.path+'img'" :src="route.meta.icon" />
        </el-menu-item>
      </el-menu>-->

        <!--<ul class="">-->

        <!--<li >-->
        <div class="navMenu">
          <span  v-bind:class='[item.name==$route.name?"active":"",item.name]' v-for="item in headerNavList">
            <a :href="item.path" :class="item.class" v-if="item.class == 'indexHome'||item.class == 'hwHome'">
              {{ item.name }}
              <img class="priceimg" :src="item.icon" v-if="item.icon" />
              <img class="musicimg" :src="item.icontext"  v-if="item.icontext" alt="">
              <img class="hwimg" :src="item.hwicon" v-if="item.hwicon" alt="" />

            </a>
            <router-link :to="{ path: item.path }" v-else>
              {{ item.name }}
              <img class="priceimg" :src="item.icon" v-if="item.icon" />
              <img class="musicimg" :src="item.icontext"  v-if="item.icontext" alt="">
            </router-link>
          </span>

        </div>

        <!--</li>-->
        <!--</ul>-->
      </div>
      <div class="header_item headerRight">
        <div class="headerPhone headerRight_item">
          <img src="//frontend.originoo.com/originoo_web/headericon/phoneicon.png" />
          4000-365-890
        </div>
        <div class="headerRight_item main_gradualChange headerRight_upgradeCompany" id="headerRight_upgradeCompany"><a href="/business">升级企业版</a></div>
        <div class="headerRight_item headerRight_freeVip freeGradient" id="headerRight_freeVip">
          <div class="headerRight_isVip" v-if="isFreeVip">VIP到期时间: {{ freeVipTime }}</div>
          <div class="headerRight_noVip" v-else><a href="/free/vip">升级VIP会员 全年无限下载</a></div>
        </div>

        <div v-if="!isLogin" class="headerRight_item headerRight_noLogin">
          <span class="pointer loginReg" @click="login('login')">登录</span>
          <span class="line_xie">/</span>
          <span class="pointer loginReg" @click="login('reg')">注册</span>
        </div>

        <div v-if="isLogin" class="headerRight_item headerRight_login">
          <a class="tidingsBox" href="/account/usermessage">
            <el-badge :value="tidingsnum" :max="99" v-if="tidingsnum > 0"><img src="//frontend.originoo.com/originoo_web/headericon/bell.png" /></el-badge>
            <img v-else src="//frontend.originoo.com/originoo_web/headericon/bell.png" />
          </a>
          <div class="loginHeaderBox">
            <img class="pointer" :src="userinfo.headImage" />

            <div class="loginBox">
              <div class="loginBoxCont">
                <a class="loginBoxContItem pointer" href="/account/index">个人主页</a>
                <a class="loginBoxContItem pointer" href="/account/orders">我的订单</a>
                <a class="loginBoxContItem pointer" href="/account/settings?type=password">修改密码</a>
                <div class="loginBoxContItem pointer" @click="loginOut">登出</div>
              </div>
            </div>
          </div>
        </div>

        <div class="headerRight_item headerRight_supplyMap pointer">
          <div class="supplyMapTitle"><a @click.stop="toGTPT">供图平台</a></div>
          <!--<div class="supplyMapBox">
						<div class="supplyMapBox_cont">
							<a href="####">立即签约</a>
							<a href="####">最新活动</a>

						</div>

					</div>-->
        </div>
      </div>
    </header>
    <aside class="app_aside main" id="app_aside">
      <div v-if="!isLogin" class="asideItem pointer redpacket" id="redpacket" @click="redpacketShowHide">
        <!---->
        <img src="//frontend.originoo.com/originoo_web/aside/redpacket.png" />
      </div>
      <div @click="returnTop" class="asideItem asideReturnTop pointer" id="asideReturnTop"><i></i></div>
      <!--是否登录 goodnum >0-->
      <div class="asideItem asideShoppingCar pointer" @click="gotoShoppingCart">
        <el-badge :value="goodnum" :max="99" v-if="isLogin && goodnum > 0" class="item"><i></i></el-badge>
        <i v-else></i>
      </div>

      <div class="asideItem asideCollection pointer" @click="gotoCollection"><i></i></div>
      <div class="asideItem asideContact pointer">
        <i></i>
        <div class="asideContactHover">
          <div class="asideContactHoverCont">
            <div class="asideContactTitle">联系方式</div>
            <div class="asideContactTel">4000-365-890</div>
            <div class="asideContactTitle">工作时间</div>
            <div class="asideContactTime">工作日 9:00-18:00</div>
            <div class="asideContactTitle asideContactQuestion">
              <a href="/commonproblem">
                问题中心
                <img src="//frontend.originoo.com/originoo_web/aside/question.png" />
              </a>
            </div>
            <div class="onlineCustomerService"><a href="javascript:" @click="open53_2()"></a></div>
          </div>
        </div>
      </div>
      <div class="asideItem asideFeedback pointer">
        <i></i>
        <div class="asideFeedbackHover">
          <div class="asideFeedbackHoverCont">
            <div class="asideFeedbackTitle">图片搜索结果是否符合您的预期?</div>
            <div class="asideFeedbackFitBox">
              <div class="asideFeedbackFitItem">
                <img class="faceImg" src="//frontend.originoo.com/originoo_web/aside/conform.png" />
                <div
                  class="asideFeedbackFit_xx pointer"
                  @click="asideFeedbackFitStatus = 'good'"
                  v-bind:class="{ active: asideFeedbackFitStatus == 'good' }"
                  style="margin-left: 8px;"
                >
                  <span></span>
                  符合
                </div>
              </div>
              <div class="asideFeedbackFitItem marginLR">
                <img class="faceImg" src="//frontend.originoo.com/originoo_web/aside/very_conform.png" />
                <div class="asideFeedbackFit_xx pointer" @click="asideFeedbackFitStatus = 'verygood'" v-bind:class="{ active: asideFeedbackFitStatus == 'verygood' }">
                  <span></span>
                  很符合
                </div>
              </div>
              <div class="asideFeedbackFitItem">
                <img class="faceImg" src="//frontend.originoo.com/originoo_web/aside/unconform.png" />
                <div class="asideFeedbackFit_xx pointer" @click="asideFeedbackFitStatus = 'nogood'" v-bind:class="{ active: asideFeedbackFitStatus == 'nogood' }">
                  <span></span>
                  不符合
                </div>
              </div>
            </div>
            <div class="asideFeedbackCont"><el-input type="textarea" resize="none" placeholder="我觉得xxxx还需要改善" v-model.trim="asideFeedbackCont"></el-input></div>
            <div class="asideFeedbackSubmit pointer" @click="feedbackSubmit">提交</div>
            <div class="asideFeedbacktips">
              提交反馈有机会
              <span>免费</span>
              下载一张
              <span>新媒体授权图片</span>
              哦
            </div>
          </div>
        </div>
      </div>
    </aside>

    <section class="app_body">
      <!--v-if="!$route.meta.hidden"-->
      <section class="app_body_user " v-if="$route.meta.type == 'user'">
        <div class="user_main">
          <div class="user_main_aside user_main_item">
            <div class="aside_userInfo">
              <div class="aside_userInfo_left"><img :src="userinfo.headImage" alt="" /></div>
              <div class="aside_userInfo_right">
                <p class="aside_userInfo_right_txt1">{{ userinfo.name }}</p>
                <p class="aside_userInfo_right_txt2">{{ userinfo.city }}</p>
              </div>
            </div>
            <el-menu
              :default-active="activeMenu"
              :unique-opened="false"
              :collapse="false"
              background-color="#fff"
              text-color="#353535"
              active-text-color="#FF7545"
              mode="vertical"
              class="el-menu-vertical-demo sideBar"
              router
            >
              <el-submenu
                v-if="route.children && route.name"
                :index="route.name"
                :key="index"
                v-for="(route, index) in $router.options.routes[$router.options.routes.length - 1].children"
              >
                <template slot="title">
                  <i :class="route.meta.iconClass"></i>
                  <span>{{ route.name }}</span>
                </template>

                <el-menu-item :index="cRoute.name" :route="cRoute" v-for="(cRoute, cIndex) in route.children" :key="cIndex">
                  <div
                    style="width:2px;height:42px;background:linear-gradient(135deg,rgba(255,185,62,1) 0%,rgba(255,74,74,1) 100%);position:absolute;margin-left:-60px;"
                    v-show="activeMenu == cRoute.name"
                  ></div>
                  <i :class="cRoute.meta.iconClass"></i>
                  {{ cRoute.name }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item :index="route.name" :route="route" v-else :data-index="index">
                <div
                  style="width:2px;height:42px;background:linear-gradient(135deg,rgba(255,185,62,1) 0%,rgba(255,74,74,1) 100%);position:absolute;margin-left:-36px;"
                  v-show="activeMenu == route.name"
                ></div>
                <i :class="route.meta.iconClass"></i>
                <span>{{ route.name }}</span>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="user_main_content user_main_item"><router-view></router-view></div>
        </div>
      </section>
      <section class="app_body_main" v-if="$route.meta.type == 'main'"><router-view></router-view></section>
    </section>

    <FOOTER></FOOTER>

    <div class="giftPackage" id="giftPackage">
      <div class="giftPackageBox">
        <img @click="closeGiftPackageShow" class="closeBtn pointer" src="//frontend.originoo.com/originoo_web/aside/close.png" />
        <img class="giftPackageImg" src="//frontend.originoo.com/originoo_web/aside/giftpackage.png" />
        <a href="javascript:" @click="open53_2()">联系客服</a>
        <div class="pointer" @click="login('reg')">立即领取</div>
      </div>
    </div>
  </div>
</template>

<script>
	import axios from 'axios'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from 'vuex';
	import {
		judgeLogin,
		analysisToken,
		replaceToken,
	} from './config/js/setConfig.js';
	import open53 from "./config/js/open53";
	import {
		delCookie,
		getCookie,
		setCookie
	} from './config/js/handleCookie.js';
	import {
		getFreeVipTime,
		problemFeedbackNew,
		getUserInfo,
		postUserUnreadMsgNum,
		postShopCartNum
	} from './api/api.js';
	export default {
		name: 'App',
		data() {
			return {
				resUrl2: '',
				curIndex: 0,
				nav_activeMenu: '',
				activeMenu: '',
				isFreeVip: false,
				freeVipTime: '',
				isLogin: false,
				headImg: '',
				asideFeedbackCont: '',
				asideFeedbackFitStatus: 'verygood',
				headerNavList: [],
				headerNavList1: [],
				userinfo: {
					headImage: "https://uppic.originoo.com//11/2016/08/15/p_81f8lritwvs7yly7i7hcxzasu9ow3sdd.png!/fw/400",
					name: "",
					city: ""

				},
			}
		},
		computed: {
			/********** 得到state***********/
			...mapState({
				tidingsnum: state => state.tidings.tidingsnum,
				goodnum: state => state.shoppingcarnum.goodnum,
			})

		},
		watch: {
			'$route' (to, from) {
			//	//console.log(to, 72)
				let path_router = to.path;
				this.handleGradeMainFree(path_router);
				this.activeMenu = this.$route.name;
				this.nav_activeMenu = this.$route.name;
				if(this.$route.name == '收藏夹详情') {
					this.activeMenu = '收藏夹'
				}
				//console.log(this.activeMenu, this.nav_activeMenu, 'thisthisthisthisthisthis')
				this.scroll();
				this.routeChangeJudgeLogin();
				this.freeVIPTIME(path_router);
				this.handleNavMenu()

			}
		},
		beforeCreate() {
			//每隔1小时调用一次
			replaceToken()
			let timer = setInterval(function() {
				replaceToken()

			}, 3600000)
		},
		created() {
			//console.log(window.navigator,'window.navigatorwindow.navigator')

			this.headerNavList1 = [
    //     {
				// 	path: '/free',
				// 	name: '免费专区',
				// 	class: 'freeHome',
				// 	icon: '',
    //       icontext:''
				// },
				 {
				 	path: '/',
				 	name: '创意图片',
				 	class: 'indexHome',
				 	icon: '',
             icontext:''
				 },

				 {
				 	path: '/?vector',
				 	name: '设计素材',
				 	class: 'indexHome',
				 	icon: '',
             icontext:''
				 },

				{
					path: '/premium',
					name: '高端图片',
					class: 'premiumHome',
					icon: '',
          icontext:''
				},
				{
					path: '/movie',
					name: '创意视频',
					class: 'videoHome',
					icon: '',
          icontext:''
				},
				{
					path: '/musicsearch',
					name: '版权音乐',
					class: 'musicIndexSearch',
					icon: '',
          icontext:'//frontend.originoo.com/originoo_web/headericon/new.png'

				},
				{
					path: '/yunpai',
					name: '照片直播',
					class: 'yunpaiHome',
					icon: '',
          icontext:''
				},
				{
					path: '/price',
					name: 'VIP价格',
					class: 'priceHome',
					icon: '//frontend.originoo.com/static/sites/originoo/img/hot.png',
          icontext:''
				},
//				{
//					path: 'https://cp.originoo.com/hw_index',
//					name: '华为主题大赛',
//					class: 'hwHome',
//					icon: '',
//        icontext:'',
//        hwicon:'https://frontend.originoo.com/ocp/huawei/hw_hot.png',
//				},

			]

			this.headerNavList = this.headerNavList1;

		},
		beforeMount() {

		},
		mounted() {

			this.resUrl2 = this.$store.state.api.api_hu;
			//console.log(this.resUrl2);
			let token = getCookie('token');
			// var token = this.token;

			// if(token == null || token == "") {
			// 	window.location.href = "//www.originoo.com";
			// 	return;
			// }
			let _this = this;
			$(document).scroll(function() {
				_this.scroll()
			})

			this.handleNavMenu()

			if(token) {
				this.getuserinfo();
				this.getTidingsNum()
				this.handleUserInfo()

				this.getShopCartNum();
			}
			this.judgeThirdLogin()
		},

		methods: {
      open53_2(){
        open53.open53();
      },
			toGTPT(){

				if(getCookie('token')){
					window.location.href="//cp.originoo.com?para="+Base64.encode(getCookie('token'))
				}else{
					window.location.href="//cp.originoo.com"
				}



			},
			judgeThirdLogin() {
				//console.log(getCookie('qqToken'), getCookie('wechatToken'), "第三方登录存在cookie")
				if(getCookie('qqToken') || getCookie('wechatToken')) {
					this.$refs.login.loginThird('loginThird');
				}

			},
			getTidingsNum() {
				////console.log(44545454)

				let asd = Math.random()
				//调用获取消息数量的接口
				postUserUnreadMsgNum({}).then(res => {
					//console.log(res.data, 'let asd = Math.random()')
					//调用的是mutations中的modifyTidingsnum//去修改消息数量

					this.$store.commit('modifyTidingsnum', res.data)
				}).catch(err => {
					//console.log(err, 'cw')
				})

			},
			getShopCartNum() {
				postShopCartNum({}).then(res => {

					this.$store.commit('modifyGoodNum', res.data)
				}).catch(err => {
					//console.log(err, 'cw')
				})
			},

			getuserinfo() { //获取个人信息
				getUserInfo({}).then(res => {
					//console.log(res.data)
					this.userinfo.city = res.data.city;

				})
			},

			handleNavMenu() {
				let path = this.$route.path;

				//console.log(path, 490490)

//				if(path == '/free') {
//					$(".freeHome").addClass('active').siblings().removeClass('active')
//
//				} else if(path == '/premium') {
//					//console.log(520)
//					$(".premiumHome").addClass('active').siblings().removeClass('active')
//				} else if(path == '/movie') {
//					$(".videoHome").addClass('active').siblings().removeClass('active')
//
//				} else if(path == '/yunpai') {
//					$(".yunpaiHome").addClass('active').siblings().removeClass('active')
//
//				} else if(path == '/price') {
//					$(".priceHome").addClass('active').siblings().removeClass('active')
//
//				} else {
//					$(".navMenu span").removeClass('active')
//
//				}

				//

			},
			//获取免费会员到期时间
			freeVIPTIME(path) {
				////console.log(427, '免费会员时间', path)

				if(path.includes('free')) {
					if(judgeLogin) {
						////console.log('判断登录--登录')
						getFreeVipTime({}).then(res => {
						//	//console.log(res, '免费会员时间')
							let data = res.data;
							if(data.user_freevip == 'YES') {
								this.isFreeVip = true;
								let time = data.end_time;

								time = new Date(time);
							//	//console.log(time)
								let year = time.getFullYear()
								let month = time.getMonth() + 1;
								let day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
								this.freeVipTime = year + '-' + month + '-' + day;
							} else {
								this.isFreeVip = false;
							}

						}).catch(err => {
							//console.log(err, '错误')
							this.isFreeVip = false;
						})

					} else {
						////console.log('判断登录--未登录')
						this.isFreeVip = false;
					}

				} else {

				}

			},

			loginOut() {
				////console.log('退出登录')
				//清楚搜友cookie
				let path = this.$route.path;
				////console.log(path, '退出登录')
				delCookie('token')
			//	//console.log(getCookie('token'), '55545')

				if(path.includes('account')) {
					//					//返回首页
					window.location.href = 'https://www.originoo.com';
				} else {
					window.location.reload();
				}
			},
			gotoShoppingCart() {
				if(judgeLogin) {
					this.$router.push({
						path: '/shoppingcart'
					})
				} else {
					this.$refs.login.loginTemplate('login');
				}
			},
			gotoCollection() {

				if(judgeLogin) {
					this.$router.push({
						path: '/account/collections'
					})

				} else {
					this.$refs.login.loginTemplate('login');
				}

			},

			handleUserInfo() {
				let tokenObj = analysisToken();
				if(tokenObj) { //判断token存在不存在
					////console.log(tokenObj.headImage, 111111111111111111111111111)
					if(tokenObj.headImage) { //判断解析token中的头像存在不存在
						this.userinfo.headImage = tokenObj.headImage;
						this.headImg = tokenObj.headImage;
						this.userinfo.name = tokenObj.username;
					} else {
						this.userinfo.headImage = "https://uppic.originoo.com//11/2016/08/15/p_81f8lritwvs7yly7i7hcxzasu9ow3sdd.png!/fw/400"
						this.headImg = "https://uppic.originoo.com//11/2016/08/15/p_81f8lritwvs7yly7i7hcxzasu9ow3sdd.png!/fw/400";
						this.userinfo.name = tokenObj.username;
					}
				} else {
					this.headImg = "https://uppic.originoo.com//11/2016/08/15/p_81f8lritwvs7yly7i7hcxzasu9ow3sdd.png!/fw/400";
					this.userinfo.headImage = "https://uppic.originoo.com//11/2016/08/15/p_81f8lritwvs7yly7i7hcxzasu9ow3sdd.png!/fw/400"
				}
			//	//console.log(tokenObj, 'tokenObj', 40711111111111111111111111111111111111)
			},
			returnTop() {
				//console.log(125)
				//$(window).scrollTop(0)
				$('html,body').animate({
					scrollTop: 0
				}, 1000);
			},
			redpacketShowHide() {
				let display = $("#giftPackage").css('display')
			//	//console.log(display)
				if(display == 'none') {
					$("#giftPackage").slideDown()
				} else {
					$("#giftPackage").slideUp()
				}
			},
			closeGiftPackageShow() {
			//	//console.log(430);

				let startLeft = $('.giftPackageImg').offset().left;
				let startTop = $('.giftPackageImg').offset().top;
				let endLeft = $('.redpacket').offset().left;
				let endTop = $('.redpacket').offset().top;
				let imgW = $('.giftPackageImg').width()
				let imgH = $('.giftPackageImg').height()

				//console.log($('.giftPackageImg'), startLeft, startTop, 'start')
				//console.log(endLeft, endTop, 'end')

				let endTop1 = endTop - $(window).scrollTop() + $('.redpacket').height() / 2
				let img = '<img id="imganimate" style="position:fixed;width:' + imgW + 'px;height:' + imgH + 'px; bottom: 0; left:calc(50% - 396px);" src="//frontend.originoo.com/originoo_web/aside/giftpackage.png" />'
				$(".giftPackage").hide()
				$("body").append(img);
				$('#imganimate').animate({
					left: endLeft + 24 + 'px',
					top: endTop1 + 'px',
					width: '0px',
					height: '0px',
					opacity: 0.3,
				}, 500, function() {
					$('#imganimate').remove()
				})

			},
			feedbackSubmit() {
				//console.log(this.asideFeedbackFitStatus)
				//console.log(this.asideFeedbackCont, 410)

				let ns = '很符合';
				if(this.asideFeedbackFitStatus == 'nogood') {
					ns = '不符合';
				} else if(this.asideFeedbackFitStatus == 'good') {
					ns = '符合';
				} else {
					//verygood
					ns = '很符合';
				}

				if(!this.asideFeedbackCont) {
					this.$message.warning('反馈内容不能为空')
					return
				}

				let params = {};


				params.company = '';
				params.contactInformation = '';
				params.content = '图片搜索结果是' + ns + '预期。' + '还需要改善的是' + this.asideFeedbackCont;


				params.position = '';
				params.source = 'feedback';
				params.title = '';
				params.userName ='';


				problemFeedbackNew(params).then(res => {
					this.$message.success('信息提交成功')
				}).catch(err => {
					//console.log(err, '错误')
				})

			},
			routeChangeJudgeLogin() {
				//判断是否登录
				this.isLogin = judgeLogin;
			//	//console.log(judgeLogin, '判断是否登录')
			},
			scroll() {
				let h = $(window).scrollTop();
				//              //console.log(h,473473)
				if(h > 150) {
					$("#asideReturnTop").show()
				} else {
					$("#asideReturnTop").hide()
				}

//				//console.log(this.$route, '839app')
				let pathname = this.$route.name;
				let isappheader = pathname == '搜索' ||pathname == '版权音乐'|| pathname == "高端详情"||pathname == "高端搜索"||pathname =="音乐详情"
//				//console.log(isappheader,'isappheader')

				if(isappheader){
//					//console.log(isappheader,'isappheader1')
					$('#app_header').css({
							'position': 'relative'
						})

				} else {
//					//console.log(isappheader,'isappheader2')
					if(h > 10) {
						//console.log(isappheader,'isappheader3')
						$('#app_header').css({
							'position': 'fixed',
							'top':'0px'
						})
					} else {
//						//console.log(isappheader,'isappheader4')
						$('#app_header').css({
							'position': 'relative'
						})
					}
				}

			},
			login(val) {
				this.$refs.login.loginTemplate(val);
			},

			handleGradeMainFree(path_router) {
				//处理高端 免费 主要的 头部  底部 侧边
				if(path_router.includes('premium')) {
				//	//console.log(350)
					$('#app_header').removeClass('main')
					$('#app_header').removeClass('free')
					$('#app_header').addClass('grade')
					$('#footer_comm').removeClass('main')
					$('#footer_comm').removeClass('free')
					$('#footer_comm').addClass('grade')
					$("#headerRight_upgradeCompany").css('display', 'inline-block')
					$("#headerRight_upgradeCompany").addClass('grade_gradualChange').removeClass('main_gradualChange')

					$("#app_aside").addClass('grade').removeClass('free').removeClass('main')

					$("#headerRight_freeVip").css('display', 'none')
				} else if(path_router.includes('free')) {
					////console.log(360)
					$('#app_header').removeClass('main')
					$('#app_header').removeClass('grade')
					$('#app_header').addClass('free')
					$('#footer_comm').removeClass('main')
					$('#footer_comm').removeClass('grade')
					$('#footer_comm').addClass('free')
					$("#headerRight_upgradeCompany").addClass('main_gradualChange').removeClass('grade_gradualChange')
					$("#headerRight_upgradeCompany").css('display', 'none')
					$("#headerRight_freeVip").css('display', 'inline-block')

					$("#app_aside").addClass('free').removeClass('grade').removeClass('main')

				} else {
					////console.log(372)
					$('#app_header').removeClass('free')
					$('#app_header').removeClass('grade')
					$('#app_header').addClass('main')
					$('#footer_comm').removeClass('free')
					$('#footer_comm').removeClass('grade')
					$('#footer_comm').addClass('main')
					$("#headerRight_upgradeCompany").addClass('main_gradualChange').removeClass('grade_gradualChange')
					$("#headerRight_upgradeCompany").css('display', 'inline-block')
					$("#headerRight_freeVip").css('display', 'none')
					$("#app_aside").addClass('main').removeClass('grade').removeClass('free')
				}

			},

		}

	}

</script>

<style lang="scss">
@import './config/css/color.scss';
#app {
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  .app_header {
    position: relative;
    z-index: 1000;
    width: 100%;
    min-width: 1280px;
    box-sizing: border-box;
    height: 50px;
    background: $background_35;
    padding-left: 40px;
    box-sizing: border-box;
    /*font-size:0px;*/
    .header_item {
      display: inline-block;
      vertical-align: top;
      .logo {
        vertical-align: -17.5px;
        /*padding-right: 20px;*/
        img {
          width: 87px;
          height: 20px;
        }
      }
      .navMenu {
        height: 50px !important;
        /*display: inline-block;*/
        /*margin-left: 10px;*/
        margin-left: 25px;
        span {
          &.active {
            a {
              color: $font_color_FF7545;
            }
          }
          a {
            height: 50px;
            line-height: 50px;
            padding: 0;
            margin: 0 10px;
            border: none;
            color: #ffffff;
            display: inline-block;
            position: relative;
            font-size: 14px;

            &.hwHome{
            	margin-left: 15px;
            }

            &:hover {
              background: transparent !important;
              color: $font_color_FF7545 !important;
            }
            .priceimg {
              position: absolute;
              width: 8px;
              height: 13px;
              top: 10px;
              right: -10px;
            }
            .musicimg{
              position: absolute;
              width: 25px;
              height: 12px;
              top: 4px;
              right: -20px;
            }
            .hwimg{
            	position: absolute;
              width: 12px;
              height: 20px;
              top: 6px;
              right: -15px;
            }
          }
        }
      }
      /*el-menu-demo el-menu--horizontal el-menu*/
      /*.el-menu {
					height: 50px !important;
					display: inline-block;
					margin-left: 10px;
					.el-menu-item {
						height: 50px;
						line-height: 50px;
						padding: 0;
						margin: 0 5px;
						border: none;
						position: relative;
						&:hover {
							background: transparent !important;
							color: $font_color_FF7545 !important;
						}
						&.is-active {
							border-bottom: none;
						}
						.priceimg {
							position: absolute;
							width: 8px;
							height: 13px;
							top: 10px;
							right: -10px;
						}
					}
					&.el-menu--horizontal {
						border: none;
					}
				}*/
      &.headerRight {
        position: absolute;
        top: 0;
        right: 0;
        color: white;
        padding: 10px 0;
        font-size: 14px;
        .headerRight_item {
          display: inline-block;
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          &.headerPhone {
            img {
              width: 15px;
              height: 21px;
              vertical-align: text-bottom;
              margin-right: 5px;
            }
            margin-right: 10px;
          }
          &.headerRight_upgradeCompany {
            display: inline-block;
            width: 100px;
            height: 30px;
            text-align: center;
            border-radius: 15px;
            a {
              color: #ffffff;
              width: 100%;
              height: 100%;
              display: block;
            }
          }
          &.headerRight_freeVip {
            display: none;
            height: 30px;
            text-align: center;
            border-radius: 15px;
            .headerRight_isVip {
              width: 220px;
            }
            .headerRight_noVip {
              width: 220px;
              a {
                color: white;
              }
            }
          }
          &.headerRight_noLogin {
            margin-left: 10px;
            .line_xie {
              margin-left: 2px;
              margin-right: 2px;
            }
            .loginReg {
              &:hover {
                color: #ff7545;
              }
            }
          }
          &.headerRight_login {
            margin-left: 10px;
            /*display: none;*/
            .tidingsBox {
              .el-badge {
                height: 18px;
                vertical-align: -5px;
                .el-badge__content {
                  border: none;
                  color: #ffffff;
                  background: #e64437;
                }
                img {
                  vertical-align: 0;
                  width: 14px;
                  height: 18px;
                }
              }
              img {
                vertical-align: middle;
                width: 14px;
                height: 18px;
              }
            }
            .loginHeaderBox {
              vertical-align: top;
              display: inline-block;
              margin-left: 20px;
              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
              }
              position: relative;
              &:hover .loginBox {
                display: block;
              }
              .loginBox {
                display: none;
                position: absolute;
                top: 40px;
                z-index: 152;
                width: 100px;
                right: -20px;
                background: #57d6d6;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
                border-radius: 0 0 4px 4px;
                .loginBoxCont {
                  padding: 5px 0;
                  border-radius: 0 0 4px 4px;
                  background: #ffffff;
                  .loginBoxContItem {
                    display: block;
                    height: 30px;
                    line-height: 30px;
                    color: #353535;
                    padding-left: 15px;
                    &:hover {
                      background: #eeeeee;
                      color: #ff7545;
                    }
                  }
                }
              }
            }
          }
          &.headerRight_supplyMap {
            border-left: 1px solid #ffffff;
            width: 107px;
            box-sizing: border-box;
            /*padding-left: 25px;
							padding-right: 25px;*/
            text-align: center;
            margin-left: 15px;
            /*background: darkgoldenrod;*/
            position: relative;
            .supplyMapTitle {
              width: 106px;
              a {
                color: #ffffff;
                &:hover {
                  color: #ff7545;
                }
              }
              &:hover {
                color: #ff7545;
              }
            }
            &:hover .supplyMapBox {
              display: block;
            }
            .supplyMapBox {
              display: none;
              padding-top: 10px;
              background: transparent;
              position: absolute;
              z-index: 152;
              top: 30px;
              left: 0;
              /*height: 70px;*/
              box-sizing: border-box;
              width: 96px;
              border-radius: 0 0 4px 4px;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
              .supplyMapBox_cont {
                background: #ffffff;
                padding: 5px 0;
                border-radius: 0 0 4px 4px;
                a {
                  display: block;
                  height: 30px;
                  width: 100%;
                  text-align: center;
                  line-height: 30px;
                  color: #353535;
                  &:hover {
                    background: #eeeeee;
                    color: #ff7545;
                  }
                }
              }
            }
          }
        }
      }
    }
    &.main {
      .navMenu {
        span {
          &.active {
            a {
            }
          }
        }
        a {
          &:hover {
          }
          &.active {
          }
        }
      }
      /*.el-menu {
					.el-menu-item {
						&:hover {

						}
						&.is-active {

						}
					}
				}*/
      .headerRight_supplyMap {
        .supplyMapTitle {
          /*&:hover{
							color: #FF7545;
						}*/
        }
        .supplyMapBox {
          .supplyMapBox_cont {
            a {
              &:hover {
                /*color: #FF7545;*/
              }
            }
          }
        }
      }
    }
    &.grade {
      .navMenu {
        span {
          &.active {
            a {
              color: $font_color_DEBA7E;
            }
          }
          a {
            color: #ffffff;
            &:hover {
              background: transparent !important;
              color: $font_color_DEBA7E !important;
            }
            &.active {
            }
            &.router-link-active {
              /*color: $font_color_DEBA7E;*/
            }
          }
        }
      }
      /*.el-menu {
					.el-menu-item {
						&:hover {
							color: $font_color_DEBA7E !important;
						}
						&.is-active {
							color: $font_color_DEBA7E !important;
						}
					}
				}*/
      .headerRight_noLogin {
        .loginReg {
          &:hover {
            color: #deba7e !important;
          }
        }
      }
      .headerRight_login {
        /*.loginHeaderBox {
						.loginBox {*/
        /*.loginBoxCont {*/
        .loginBoxContItem {
          &:hover {
            color: #deba7e !important;
          }
        }
      }
      .headerRight_supplyMap {
        .supplyMapTitle {
          a {
            &:hover {
              color: #deba7e !important;
            }
          }
        }
        .supplyMapBox {
          .supplyMapBox_cont {
            a {
              &:hover {
                color: #deba7e !important;
              }
            }
          }
        }
      }
    }
    &.free {
      .navMenu {
        a {
          /*color: #FFFFFF;*/
          &:hover {
            /*background: transparent !important;
							color: $font_color_DEBA7E !important;*/
          }
          &.active {
            /*color:$font_color_DEBA7E;*/
          }
          &.router-link-active {
          }
        }
      }
      .el-menu {
        .el-menu-item {
          &:hover {
            /*color: #57D6D6 !important;*/
          }
          &.is-active {
            /*color: #57D6D6 !important;*/
          }
        }
      }
    }
  }
  /*侧边导航*/
  .app_aside {
    width: 48px;
    height: auto;
    position: fixed;
    right: 35px;
    bottom: 65px;
    /*background: red;*/
    z-index: 1500;
    .asideItem {
      margin-top: 10px;
      border-radius: 50%;
      width: 48px;
      height: 48px;
      background: #ffffff;
      box-sizing: border-box;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      &.redpacket {
        width: 64px;
        height: 64px;
        border-radius: 0;
        background: transparent !important;
        box-shadow: none;
        img {
          width: 64px;
          height: 64px;
        }
      }
      i {
        background-repeat: no-repeat;
        background-size: cover;
      }
      &:hover {
        background: -webkit-linear-gradient(-45deg, #ffb93e 0%, #ff4a4a 100%);
        background: -moz-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
        background: -ms-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
        background: -o-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
        background: linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
      }
      &.asideReturnTop {
        display: none;
        padding: 11px 11px 12px;
        i {
          display: block;
          width: 26px;
          height: 25px;
          background-image: url('//frontend.originoo.com/originoo_web/aside/returntop.png');
        }
        &:hover i {
          background-image: url('//frontend.originoo.com/originoo_web/aside/returntop_active.png') !important;
        }
      }
      &.asideShoppingCar {
        padding: 14px 11px 12px 13px;
        .el-badge {
          .el-badge__content {
            border: none;
            color: #ffffff;
            background: #e64437;
            &.is-fixed {
              top: -8px;
              right: 0;
            }
          }
        }
        i {
          display: block;
          width: 22px;
          height: 22px;
          background-image: url('//frontend.originoo.com/originoo_web/aside/shoppingcar.png');
        }
        &:hover i {
          background-image: url('//frontend.originoo.com/originoo_web/aside/shoppingcar_active.png') !important;
        }
      }
      &.asideCollection {
        padding: 12px 11px 12px 12px;
        i {
          display: block;
          width: 25px;
          height: 24px;
          background-image: url('//frontend.originoo.com/originoo_web/aside/collection.png');
        }
        &:hover i {
          background-image: url('//frontend.originoo.com/originoo_web/aside/collection_active.png') !important;
        }
      }
      &.asideContact {
        padding: 11px 12px;
        position: relative;
        i {
          display: block;
          width: 24px;
          height: 26px;
          background-image: url('//frontend.originoo.com/originoo_web/aside/customservice.png');
        }
        &:hover {
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/customservice_active.png') !important;
          }
          .asideContactHover {
            display: block;
          }
        }
        .asideContactHover {
          display: none;
          position: absolute;
          height: 214px;
          width: 170px;
          background: transparent;
          top: -84px;
          right: 48px;
          border-radius: 4px;
          box-sizing: border-box;
          padding-right: 10px;
          cursor: auto;
          .asideContactHoverCont {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
            box-sizing: border-box;
            width: 160px;
            height: 214px;
            background: #ffffff;
            padding: 20px;
            border-radius: 4px;
            .asideContactTitle {
              font-size: 14px;
              height: 20px;
              line-height: 20px;
              color: #b2b2b2;
              &.asideContactQuestion {
                a {
                  color: #b2b2b2;
                  img {
                    width: 15px;
                    height: 15px;
                    vertical-align: -2.5px;
                    margin-left: 6px;
                  }
                }
              }
            }
            .asideContactTel {
              color: #ff7545;
              font-size: 16px;
              font-weight: 600;
              height: 22px;
              line-height: 22px;
              margin-bottom: 6px;
              margin-top: 6px;
            }
            .asideContactTime {
              color: #353535;
              font-size: 14px;
              font-weight: 500;
              height: 20px;
              line-height: 20px;
              margin-bottom: 6px;
              margin-top: 6px;
            }
            .onlineCustomerService {
              width: 111px;
              height: 30px;
              margin: 20px auto 0;
              a {
                display: block;
                width: 111px;
                height: 30px;
                background-size: cover;
                background-repeat: no-repeat;
                background-image: url('//frontend.originoo.com/originoo_web/aside/online_customer.png');
              }
            }
          }
        }
      }
      &.asideFeedback {
        padding: 13px 13px 12px 14px;
        position: relative;
        i {
          display: block;
          width: 21px;
          height: 23px;
          background-image: url('//frontend.originoo.com/originoo_web/aside/feedback.png');
        }
        &:hover {
          .asideFeedbackHover {
            display: block;
          }
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/feedback_active.png') !important;
          }
        }
        .asideFeedbackHover {
          position: absolute;
          width: 312px;
          height: 385px;
          top: -287px;
          right: 48px;
          display: none;
          background: transparent;
          box-sizing: border-box;
          padding-right: 10px;
          border-radius: 4px;
          cursor: auto;
          .asideFeedbackHoverCont {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
            background: #ffffff;
            width: 302px;
            height: 385px;
            padding: 20px;
            box-sizing: border-box;
            border-radius: 4px;
            .asideFeedbackTitle {
              height: 20px;
              font-size: 14px;
              color: #353535;
              line-height: 20px;
              margin-bottom: 15px;
            }
            .asideFeedbackFitBox {
              .asideFeedbackFitItem {
                width: 60px;
                display: inline-block;
                vertical-align: top;
                padding-top: 5px;
                &.marginLR {
                  margin-left: 35px;
                  margin-right: 35px;
                }
                .faceImg {
                  width: 36px;
                  height: 36px;
                  margin-left: 20px;
                }
                .asideFeedbackFit_xx {
                  height: 20px;
                  line-height: 20px;
                  color: #353535;
                  font-weight: 500px;
                  font-size: 14px;
                  margin-top: 10px;
                  span {
                    display: inline-block;
                    width: 13px;
                    height: 13px;
                    margin-right: 5px;
                    vertical-align: -2px;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-image: url('//frontend.originoo.com/originoo_web/aside/unselected.png');
                  }
                  &.active {
                    span {
                      background-image: url('//frontend.originoo.com/originoo_web/aside/selected.png');
                    }
                  }
                }
              }
            }
            .asideFeedbackCont {
              margin-top: 15px;
              width: 262px;
              height: 161px;
              .el-textarea {
                textarea {
                  width: 262px;
                  height: 161px;
                }
              }
            }
            .asideFeedbackSubmit {
              margin-top: 15px;
              width: 262px;
              height: 30px;
              border-radius: 15px;
              text-align: center;
              line-height: 30px;
              color: #ffffff;
              font-size: 14px;
              background: -webkit-linear-gradient(-45deg, #ffb93e 0%, #ff4a4a 100%);
              background: -moz-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
              background: -ms-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
              background: -o-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
              background: linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
            }
            .asideFeedbacktips {
              margin-top: 6px;
              text-align: center;
              height: 17px;
              font-size: 12px;
              color: #b2b2b2;
              line-height: 17px;
              span {
                color: #ff7545;
              }
            }
          }
        }
      }
    }
    &.main {
    }
    &.grade {
      .asideItem {
        &:hover {
          background: #deba7e;
        }
        &.asideReturnTop {
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/returntop_grade.png');
          }
        }
        &.asideShoppingCar {
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/shoppingcar_grade.png');
          }
        }
        &.asideCollection {
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/collection_grade.png');
          }
        }
        &.asideContact {
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/customservice_grade.png');
          }
          .asideContactHover {
            .asideContactHoverCont {
              .asideContactTel {
                color: #deba7e;
              }
              .onlineCustomerService {
                a {
                  background-image: url('//frontend.originoo.com/originoo_web/aside/online_customer_grade.png');
                }
              }
            }
          }
        }
        &.asideFeedback {
          i {
            background-image: url('//frontend.originoo.com/originoo_web/aside/feedback_grade.png');
          }
          .asideFeedbackHover {
            .asideFeedbackHoverCont {
              .asideFeedbackSubmit {
                background: #deba7e;
              }
              .asideFeedbacktips {
                span {
                  color: #deba7e;
                }
              }
            }
          }
        }
      }
    }
    &.free {
    }
  }
  .app_body {
    min-height: calc(100% - 579px);
    .app_body_user {
      width: 100%;
      min-width: 1280px;
      background: #f7f7f7;
      padding-top: 30px;
      .user_main {
        width: 1200px;
        margin: 0 auto;
        font-size: 0;
        display: flex;
        .user_main_item {
          display: inline-block;
          vertical-align: top;
          &.user_main_aside {
            width: 248px;
            background: #fff;
            height: 855px;
            .el-menu.el-menu--inline {
              .el-menu-item {
                padding-left: 60px !important;
              }
            }
            .el-menu {
              border-right: none;
              .el-menu-item {
                padding-left: 36px !important;
                font-size: 16px;
                color: #353535;
                // background-color: red!important;
                height: 42px;
                line-height: 42px;
              }
              .el-menu-item:hover {
                background-color: rgba(247, 247, 247, 1) !important;
              }
              .el-submenu__title {
                padding-right: 25px !important;
                padding-left: 36px !important;
                font-size: 16px;
                height: 42px;
                color: #353535;
                line-height: 42px;
              }
              .el-submenu__title:hover {
                background-color: rgba(247, 247, 247, 1) !important;
              }
            }
            .aside_userInfo {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 28px 0;
              width: 247px;
              .aside_userInfo_left {
                img {
                  width: 62px;
                  height: 62px;
                  border-radius: 50%;
                }
              }
              .aside_userInfo_right {
                margin-left: 14px;
                .aside_userInfo_right_txt1 {
                  color: #353535;
                  font-size: 18px;
                  font-family: PingFangSC-Medium;
                  font-weight: 600;
                  width: 134px;
                  height: 25px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .aside_userInfo_right_txt2 {
                  color: #b2b2b2;
                  font-size: 14px;
                  margin-top: 5px;
                }
              }
            }
          }
          &.user_main_content {
            width: 932px;
            margin-left: 20px;
            font-size: 14px;
          }
        }
      }
    }
    .app_body_main {
      width: 100%;
      min-width: 1280px;
      /*height: 100%;
				height: calc(100% - 579px);*/
      background: #ffffff;
    }
  }

  .giftPackage {
    display: none;
    width: 100%;
    height: 231px;
    position: fixed;
    z-index: 1600;
    bottom: 0;
    text-align: center;
    .giftPackageBox {
      width: 791px;
      height: 231px;
      position: relative;
      margin: 0 auto;
      .giftPackageImg {
        width: 791px;
        height: 231px;
      }
      .closeBtn {
        width: 25px;
        height: 50px;
        position: absolute;
        right: 45px;
        top: 28px;
      }
      a {
        display: block;
        width: 108px;
        height: 34px;
        background: rgba(255, 255, 255, 0.5);
        position: absolute;
        right: 198px;
        bottom: 19px;
        color: #ffffff;
        text-align: center;
        line-height: 34px;
      }
      div {
        width: 108px;
        height: 34px;
        position: absolute;
        bottom: 19px;
        right: 70px;
        color: #ffffff;
        text-align: center;
        line-height: 34px;
        background: -webkit-linear-gradient(-45deg, #ffb93e 0%, #ff4a4a 100%);
        background: -moz-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
        background: -ms-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
        background: -o-linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
        background: linear-gradient(135deg, #ffb93e 0%, #ff4a4a 100%);
      }
    }
  }
}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #909399 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue